import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import EvaluateComponent from '../components/evaluate/evaluate.jsx';
import {getXueyuanListRequest, getReasonListRequest,dianzanStudentDanRequest,dianzanStudentDuoRequest} from "../service/reason";


class EvaluateContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'clickXueyuan',
            'clickXueke',
            'clickLiyou',
            'clickHonglingjinTab'
        ]);
        this.state = {
            option: {},
            num: 9,
            xueyuanList: [],
            xueyuan_code: '',
            xueyuan_name: '',
            xuekeList: [],
            xueke_code: '',
            xueke_name: '',
            liyouList: [],
            class_code: props.banji_code,
            honglingjinTab: 0,
            jichuZhangList: [],
            teseZhangList: [],
            yixingData: {},
            laodongJiatingList: [],
            laodongXuexiaoList: [],
            laodongShehuiList: [],
            isClick:true,
            xiaodangjiaList: [],
            xiaogongjiangList: [],
            xiaoboshiList: [],
            xiaohuojuList: [],
        }

    }

    componentDidMount() {
        getXueyuanListRequest(this.state.class_code, (data) => {
            console.log(data)

            if (data.data == '') {

            } else {
                this.setState({
                    xueyuanList: data.data.xueke,
                    xueyuan_code: data.data.xueke[0].xueyuan_code,
                    xuekeList: data.data.xueke[0].xueyuan_xueke,
                    xueke_code: data.data.xueke[0].xueyuan_xueke[0].xueke_code
                })
                this.getReasonList(data.data.xueke[0].xueyuan_xueke[0].xueke_code)
            }
        });
    }

    getReasonList(xueke_code) {
        getReasonListRequest(this.state.class_code, xueke_code, (data) => {
            console.log(data)

            if (data.data == '') {

            } else {
                if (xueke_code == '26') {
                    this.setState({
                        jichuZhangList: data.data.data_jichu,
                        teseZhangList: data.data.data_tese,
                        yixingData:data.data.data_yixing
                    })

                } else if (xueke_code == '27') {
                    // this.setState({
                    //     laodongJiatingList: data.data.data_jiating,
                    //     laodongXuexiaoList: data.data.data_xuexiao,
                    //     laodongShehuiList: data.data.data_shehui
                    // })
                    this.setState({
                        xiaodangjiaList: data.data.data_xiaodangjia,
                        xiaogongjiangList: data.data.data_xiaogongjiang,
                        xiaoboshiList: data.data.data_xiaoboshi,
                        xiaohuojuList: data.data.data_xiaohuoju,
                    })
                } else {
                    this.setState({
                        liyouList: data.data.zhibiao

                    })
                }
                // this.setState({
                //     liyouList:data.data.zhibiao
                //
                // })
            }
        });
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    clickXueyuan(xueyuan_code, index) {
        if (xueyuan_code == this.state.xueyuan_code) {

        } else {
            this.getReasonList(this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code)
        }
        this.setState({
            xueyuan_code: xueyuan_code,
            xuekeList: this.state.xueyuanList[index].xueyuan_xueke,
            xueke_code: this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code
        })
    }

    clickXueke(code, index) {
        if (code == this.state.xueke_code) {

        } else {
            if (code == 26) {
                this.getReasonList(code)
            } else if (code == 27) {
                this.getReasonList(code)
            } else {
                this.getReasonList(code)
            }

        }
        this.setState({
            xueke_code: code
        })


    }

    clickLiyou(dianzan_code) {
        console.log(this.props.student_pid)
        console.log(dianzan_code)
        console.log(this.props.duorenStatus)

        console.log(this.state.xueke_code)

        if(this.state.honglingjinTab==1&&this.state.xueke_code=='26'){
            this.showToast('尚未开通，敬请期待!',1500)
            return;
        }

        const { isClick } = this.state;

        if(isClick) {
            this.setState({isClick: false});

            if (this.props.duorenStatus) {
                dianzanStudentDuoRequest(this.props.student_pid, dianzan_code, this.state.xueke_code, (data) => {

                    const that = this;  // 为定时器中的setState绑定this
                    setTimeout(function () {       // 设置延迟事件，1秒后将执行
                        that.setState({ isClick: true })   // 将isClick设置为true
                    }, 1000);

                    console.log(data)
                    if (data.ret == '1') {
                        this.props.pingjiaFinish();
                    } else {
                        this.showToast(data.msg, 1500)
                    }

                })
            } else {

                // dianzanStudentDanRequest(this.props.student_pid,dianzan_code, this.state.xueke_code, (data) => {
                //     console.log(data)
                //     if(data.ret=='1'){
                //         this.props.pingjiaFinish();
                //     }else {
                //         this.showToast(data.msg,1500)
                //     }
                //
                // })
                dianzanStudentDuoRequest(this.props.student_pid, dianzan_code, this.state.xueke_code, (data) => {

                    const that = this;  // 为定时器中的setState绑定this
                    setTimeout(function () {       // 设置延迟事件，1秒后将执行
                        that.setState({ isClick: true })   // 将isClick设置为true
                    }, 1000);

                    console.log(data)
                    if (data.ret == '1') {
                        this.props.pingjiaFinish();
                    } else {
                        this.showToast(data.msg, 1500)
                    }

                })
            }

        }

    }

    clickHonglingjinTab(tab) {
        this.setState({
            honglingjinTab: tab
        })
    }

    render() {

        return (
            <EvaluateComponent
                student_name={this.props.student_name}
                xueyuanList={this.state.xueyuanList}
                xueyuan_code={this.state.xueyuan_code}
                onRequestClose={this.props.closeSelf}
                clickXueyuan={this.clickXueyuan}
                xuekeList={this.state.xuekeList}
                xueke_code={this.state.xueke_code}
                currentXueke={this.state.currentXueke}
                clickXueke={this.clickXueke}
                liyouList={this.state.liyouList}
                clickLiyou={this.clickLiyou}
                honglingjinTab={this.state.honglingjinTab}
                clickHonglingjinTab={this.clickHonglingjinTab}
                jichuZhangList={this.state.jichuZhangList}
                teseZhangList={this.state.teseZhangList}
                yixingData={this.state.yixingData}
                laodongJiatingList={this.state.laodongJiatingList}
                laodongXuexiaoList={this.state.laodongXuexiaoList}
                laodongShehuiList={this.state.laodongShehuiList}
                xiaodangjiaList={this.state.xiaodangjiaList}
                xiaogongjiangList={this.state.xiaogongjiangList}
                xiaoboshiList={this.state.xiaoboshiList}
                xiaohuojuList={this.state.xiaohuojuList}
            />
        )
    }

}

EvaluateContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EvaluateContainer);
